import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import Map from "@/components/Map.svelte";
import Sidebar from "@/components/Sidebar.svelte";
import { toolStore } from "@/stores/tools.svelte";

var root = $.from_html(`<div class="app svelte-32vxlqo41fi5s"><!> <div class="map-area svelte-32vxlqo41fi5s"><!></div></div>`);

function App($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var div = root();
	var node = $.child(div);

	Sidebar(node, {});

	var div_1 = $.sibling(node, 2);
	var node_1 = $.child(div_1);

	Map(node_1, {});
	$.reset(div_1);
	$.reset(div);
	$.template_effect(() => $.set_style(div, `--accent: ${toolStore.accent ?? ''}; --accent-dim: ${toolStore.accent ?? ''}33;`));
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	App = $.hmr(App);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-32vxlqo41fi5s');
		App[$.HMR].update(module.default);
	});
}

export default App;
import "bun-svelte:App.svelte-22377wmzxb10g-style.css";